import { useMemo } from 'react'
import { useClientLogin } from './useClientLogin'
import { useVenue } from './useVenue'
import type { WidgetContainerProps } from '../components'

export function useGetSevenroomsLogin() {
  const { newResWidgetSrLoginEnabled } = useVenue()
  const {
    setClientLoginDetails,
    onClientDelete,
    onClientLogout,
    isClientLoginLoading,
    provider: loginProvider,
    userInfo: { firstName: userFirstName, lastName: userLastName, profilePictureUrl: userImage },
  } = useClientLogin()

  const sevenRoomsLogin = useMemo(() => {
    if (!newResWidgetSrLoginEnabled) {
      return undefined
    }
    const onLogin: Required<WidgetContainerProps>['sevenRoomsLogin']['onLogin'] = userInfo => {
      setClientLoginDetails('sevenrooms', userInfo)
    }

    const onUpdate: Required<WidgetContainerProps>['sevenRoomsLogin']['onUpdate'] = userInfo => {
      setClientLoginDetails('sevenrooms', userInfo)
    }

    return {
      onLogin,
      onUpdate,
      onLogout: onClientLogout,
      onDelete: onClientDelete,
      isLoading: isClientLoginLoading,
      ...(loginProvider === 'sevenrooms' ? { userFirstName, userLastName, userImage } : {}),
    }
  }, [
    newResWidgetSrLoginEnabled,
    onClientLogout,
    onClientDelete,
    isClientLoginLoading,
    loginProvider,
    userFirstName,
    userLastName,
    userImage,
    setClientLoginDetails,
  ])
  return sevenRoomsLogin
}
